"use strict";

export function initInScope ($scope) {
    $scope.find('.js-check-chat__textarea').keyup(function (e) {
        let $btn = $scope.find('.js-check-chat__btn');
        if($(this).val().length >= 2) {
            $btn.attr('disabled',false);
        } else {
            $btn.attr('disabled',true);
        }
    });
}